__webpack_require__.p = "/kana/";